import { Form } from "react-bootstrap";

import GenericFormGroup from "./GenericFormGroup";

const SwitchFormGroup = ({ ...props }) => {
    return (
        <GenericFormGroup
            {...props}
            renderInput={(field, canResetToDefault, errorMessage) => (
                <Form.Check
                    className={"mt-2"}
                    type="switch"
                    {...field}
                    isInvalid={!!errorMessage}
                    checked={props.checked || !!field.value}
                    style={{
                        fontWeight: canResetToDefault ? "bold" : "normal",
                    }}
                ></Form.Check>
            )}
        />
    );
};

export default SwitchFormGroup;
